import React, { useEffect } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import StudioSection from './components/StudioSection';
import TestimonialsSection from './components/TestimonialsSection';
import PricingSection from './components/PricingSection';
import InstagramSection from './components/InstagramSection';
import ReferralSection from './components/ReferralSection';
import ChallengesSection from './components/ChallengesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Add smooth scroll behavior for anchor links
    const handleSmoothScroll = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'A' && target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const id = target.getAttribute('href')?.slice(1);
        if (id) {
          const element = document.getElementById(id);
          element?.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll as any);
    return () => document.removeEventListener('click', handleSmoothScroll as any);
  }, []);

  return (
    <div className="min-h-screen bg-dark">
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <StudioSection />
      <TestimonialsSection />
      <PricingSection />
      <InstagramSection />
      <ReferralSection />
      <ChallengesSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;